<template>
  <div>
    <SearchableTable
      :panel-header="'Kassen'"
      :panel-route="'AddBalanceGroup'"
      :show-search-bar="false"
      :table-data="balanceGroups"
      :table-meta-data="tableMetaData"
      :row-click="triggerView"
      :default-sort="['attributes.name', 'asc']"
    />
  </div>
</template>

<script>
import SearchableTable from "../../helperComponents/SearchableTable.vue";
import Parse from "parse/dist/parse.min"

export default {
	name: "BalanceComponent",
	components: { SearchableTable },
	data() {
		return {
			balanceGroups: [],
			tableMetaData: [
				{ "id": 0, "type": "string", "label": "Name", "field": "name", "sortField": "attributes.name" }
			]
		}
	},
	async mounted() {
		await this.query()
	},
	methods: {
		async query() {
			const query = new Parse.Query("BalanceGroup").notEqualTo("deleted", true).include("budgets");
			this.balanceGroups = await query.find()
		},
		triggerView(balanceGroup) {
			this.$router.push({
				name: "ViewBalanceGroup",
				params: { id: balanceGroup.id, balanceGroup: balanceGroup }
			});
		}
	}
}
</script>

<style scoped></style>
